<template>
    <div>
        <ul class="nav nav-tabs nav-fill" :class="[ subMenu ? 'sub-menu' : '' ]" role="tablist">
            <li class="nav-item" v-for="tab in tabs">
                <a class="nav-link"
                   role="tab"

                   :class="{ active: activeTabName === tab.name, disabled: tab.isDisabled }"
                   @click="selectTab(tab)"
                >{{tab.label}}</a>
            </li>
        </ul>
        
        <div v-for="{name} in renderedTabs" class="tab-content" :class="{hidden: name !== activeTabName}">
            <slot :name="name" />
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            //Take either the provided initial tab, or the first tab in our collection
            this.activeTabName = this.initialTab || this.tabs[0].name;
        },
        methods: {
            selectTab(tab){
                if(tab.isDisabled !== true){
                    this.activeTabName = tab.name;
                }
            }
        },
        computed: {
            renderedTabs(){
                return this.tabs.filter(({isDisabled}) => isDisabled !== true);
            }
        },
        data: () => ({
            activeTabName: null
        }),
        props: {
            initialTab: String,
            tabs: {
                type: Array,
                required: true,
                default: () => ([{
                    name: '',
                    label: '',
                    isDisabled: false
                }])
            },
            subMenu: {
                type: Boolean,
                default: false
            }
        }
    }
</script>